// Auto-generated contract ABIs
// Run "npm run export-abis" from /contracts to regenerate

export const CrystalsGameABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_partyContract",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_combatContract",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_randomnessContract",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ContractNotSet",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidParameter",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "Unauthorized",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actionType",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actorIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      }
    ],
    "name": "CombatActionExecuted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "CombatDefeat",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "CombatStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatVictory",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "blockNumber",
        "type": "uint256"
      }
    ],
    "name": "GameSaved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint24",
        "name": "newAmount",
        "type": "uint24"
      }
    ],
    "name": "GilChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemIndex",
        "type": "uint8"
      }
    ],
    "name": "KeyItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "locationId",
        "type": "uint8"
      }
    ],
    "name": "LocationEntered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "LocationExited",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "PlayerMoved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "addToInventory",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "actionType",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "actorIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "itemOrSpellId",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "combatAction",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "combatContract",
    "outputs": [
      {
        "internalType": "contract Combat",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "combatStates",
    "outputs": [
      {
        "internalType": "bool",
        "name": "active",
        "type": "bool"
      },
      {
        "internalType": "uint8",
        "name": "currentTurn",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "turnCount",
        "type": "uint8"
      },
      {
        "internalType": "bool",
        "name": "canFlee",
        "type": "bool"
      },
      {
        "internalType": "uint8",
        "name": "backgroundId",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "commitment",
        "type": "bytes32"
      }
    ],
    "name": "commit",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "endCombat",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "locationId",
        "type": "uint8"
      }
    ],
    "name": "enterLocation",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "exitLocation",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "gameStates",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "worldX",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "worldY",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "currentMap",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "dungeonFloor",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "facing",
        "type": "uint8"
      },
      {
        "internalType": "uint24",
        "name": "gil",
        "type": "uint24"
      },
      {
        "internalType": "uint16",
        "name": "stepsToEncounter",
        "type": "uint16"
      },
      {
        "internalType": "uint256",
        "name": "storyFlags",
        "type": "uint256"
      },
      {
        "internalType": "uint32",
        "name": "keyItems",
        "type": "uint32"
      },
      {
        "internalType": "uint32",
        "name": "playTime",
        "type": "uint32"
      },
      {
        "internalType": "uint32",
        "name": "startBlock",
        "type": "uint32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getCombatState",
    "outputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "active",
            "type": "bool"
          },
          {
            "internalType": "uint8[8]",
            "name": "enemyIds",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint16[8]",
            "name": "enemyHP",
            "type": "uint16[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "enemyStatus",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[12]",
            "name": "turnQueue",
            "type": "uint8[12]"
          },
          {
            "internalType": "uint8",
            "name": "currentTurn",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "turnCount",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "canFlee",
            "type": "bool"
          },
          {
            "internalType": "uint8",
            "name": "backgroundId",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.CombatState",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getGameState",
    "outputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "enum IGameTypes.CharacterClass",
                "name": "class_",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "level",
                "type": "uint8"
              },
              {
                "internalType": "uint24",
                "name": "experience",
                "type": "uint24"
              },
              {
                "internalType": "uint16",
                "name": "currentHP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "maxHP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "currentMP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "maxMP",
                "type": "uint16"
              },
              {
                "internalType": "uint8",
                "name": "strength",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "agility",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "intelligence",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "vitality",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "luck",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "weapon",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "armor",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "helmet",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "gloves",
                "type": "uint8"
              },
              {
                "internalType": "uint8",
                "name": "accessory",
                "type": "uint8"
              },
              {
                "internalType": "enum IGameTypes.StatusEffect",
                "name": "status",
                "type": "uint8"
              },
              {
                "internalType": "uint8[8]",
                "name": "spellCharges",
                "type": "uint8[8]"
              },
              {
                "internalType": "uint8[8]",
                "name": "maxSpellCharges",
                "type": "uint8[8]"
              }
            ],
            "internalType": "struct IGameTypes.Character[4]",
            "name": "party",
            "type": "tuple[4]"
          },
          {
            "internalType": "uint8",
            "name": "worldX",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "worldY",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "currentMap",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "dungeonFloor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "facing",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "gil",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "stepsToEncounter",
            "type": "uint16"
          },
          {
            "internalType": "uint256",
            "name": "storyFlags",
            "type": "uint256"
          },
          {
            "internalType": "uint8[64]",
            "name": "inventory",
            "type": "uint8[64]"
          },
          {
            "internalType": "uint8[64]",
            "name": "inventoryQty",
            "type": "uint8[64]"
          },
          {
            "internalType": "uint32",
            "name": "keyItems",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "playTime",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "startBlock",
            "type": "uint32"
          }
        ],
        "internalType": "struct IGameTypes.GameState",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getParty",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character[4]",
        "name": "",
        "type": "tuple[4]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPosition",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "hasActiveGame",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "hasGame",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8",
        "name": "itemIndex",
        "type": "uint8"
      }
    ],
    "name": "hasKeyItem",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "hasStoryFlag",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      },
      {
        "internalType": "bool",
        "name": "canFlee",
        "type": "bool"
      }
    ],
    "name": "initiateCombat",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "isInCombat",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "magicContract",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "direction",
        "type": "uint8"
      }
    ],
    "name": "move",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemIndex",
        "type": "uint8"
      }
    ],
    "name": "obtainKeyItem",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "partyContract",
    "outputs": [
      {
        "internalType": "contract Party",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "randomnessContract",
    "outputs": [
      {
        "internalType": "contract Randomness",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "removeFromInventory",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "secret",
        "type": "bytes32"
      },
      {
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "internalType": "bytes",
        "name": "actionData",
        "type": "bytes"
      }
    ],
    "name": "revealAndAct",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "worldX",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "worldY",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "currentMap",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "dungeonFloor",
        "type": "uint8"
      },
      {
        "internalType": "uint24",
        "name": "gil",
        "type": "uint24"
      },
      {
        "internalType": "uint256",
        "name": "storyFlags",
        "type": "uint256"
      },
      {
        "internalType": "uint32",
        "name": "keyItems",
        "type": "uint32"
      },
      {
        "internalType": "uint8[64]",
        "name": "inventory",
        "type": "uint8[64]"
      },
      {
        "internalType": "uint8[64]",
        "name": "inventoryQty",
        "type": "uint8[64]"
      },
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "status",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.CharacterSaveData[4]",
        "name": "partyData",
        "type": "tuple[4]"
      }
    ],
    "name": "saveGame",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint24",
        "name": "amount",
        "type": "uint24"
      }
    ],
    "name": "setGil",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_magicContract",
        "type": "address"
      }
    ],
    "name": "setMagicContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "setStoryFlag",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_worldContract",
        "type": "address"
      }
    ],
    "name": "setWorldContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "startNewGame",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "worldContract",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const PartyABI = [
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "char",
        "type": "tuple"
      }
    ],
    "name": "calculateStats",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "attack",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "defense",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "magicPower",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "hitRate",
        "type": "uint16"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "createParty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "createPartyFor",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "slot",
        "type": "uint8"
      }
    ],
    "name": "equipItem",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      }
    ],
    "name": "getCharacter",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getParty",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character[4]",
        "name": "",
        "type": "tuple[4]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "hasParty",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      }
    ],
    "name": "levelUp",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "parties",
    "outputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "level",
        "type": "uint8"
      },
      {
        "internalType": "uint24",
        "name": "experience",
        "type": "uint24"
      },
      {
        "internalType": "uint16",
        "name": "currentHP",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "maxHP",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "currentMP",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "maxMP",
        "type": "uint16"
      },
      {
        "internalType": "uint8",
        "name": "strength",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "agility",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "intelligence",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "vitality",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "luck",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "weapon",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "armor",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "helmet",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "gloves",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "accessory",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.StatusEffect",
        "name": "status",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      }
    ],
    "name": "restoreSpellCharges",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint16",
        "name": "newHP",
        "type": "uint16"
      }
    ],
    "name": "updateHP",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "status",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.CharacterSaveData[4]",
        "name": "data",
        "type": "tuple[4]"
      }
    ],
    "name": "updatePartyFor",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.StatusEffect",
        "name": "status",
        "type": "uint8"
      }
    ],
    "name": "updateStatus",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "charIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "spellLevel",
        "type": "uint8"
      }
    ],
    "name": "useSpellCharge",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;

export const CombatABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_randomness",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_party",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "attack",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "castSpell",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "combatStates",
    "outputs": [
      {
        "internalType": "bool",
        "name": "active",
        "type": "bool"
      },
      {
        "internalType": "uint8",
        "name": "currentTurn",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "turnCount",
        "type": "uint8"
      },
      {
        "internalType": "bool",
        "name": "canFlee",
        "type": "bool"
      },
      {
        "internalType": "uint8",
        "name": "backgroundId",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "flee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getCombatState",
    "outputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "active",
            "type": "bool"
          },
          {
            "internalType": "uint8[8]",
            "name": "enemyIds",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint16[8]",
            "name": "enemyHP",
            "type": "uint16[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "enemyStatus",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[12]",
            "name": "turnQueue",
            "type": "uint8[12]"
          },
          {
            "internalType": "uint8",
            "name": "currentTurn",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "turnCount",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "canFlee",
            "type": "bool"
          },
          {
            "internalType": "uint8",
            "name": "backgroundId",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.CombatState",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "isInCombat",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "party",
    "outputs": [
      {
        "internalType": "contract Party",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "randomness",
    "outputs": [
      {
        "internalType": "contract Randomness",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      },
      {
        "internalType": "bool",
        "name": "canFlee",
        "type": "bool"
      }
    ],
    "name": "startCombat",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "useItem",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;

export const MagicABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_spellData",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotCastSpell",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSpellId",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSpellTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "TargetDead",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "target",
        "type": "tuple"
      }
    ],
    "name": "applyBuff",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetStatus",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetMagicDef",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "applyStatusEffect",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetMagicDef",
        "type": "uint8"
      },
      {
        "internalType": "bool",
        "name": "isBoss",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "attemptInstantDeath",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "caster",
        "type": "tuple"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "calculateHealing",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "",
        "type": "uint16"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "caster",
        "type": "tuple"
      },
      {
        "internalType": "uint8",
        "name": "targetMagicDef",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.Element",
        "name": "targetElement",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "calculateSpellDamage",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "",
        "type": "uint16"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "caster",
        "type": "tuple"
      },
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "canCast",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "caster",
        "type": "tuple"
      },
      {
        "internalType": "uint8",
        "name": "targetIndex",
        "type": "uint8"
      },
      {
        "internalType": "uint16",
        "name": "targetCurrentHP",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "targetMaxHP",
        "type": "uint16"
      },
      {
        "internalType": "uint8",
        "name": "targetMagicDef",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "targetStatus",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.Element",
        "name": "targetElement",
        "type": "uint8"
      },
      {
        "internalType": "bool",
        "name": "isBoss",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "castSpell",
    "outputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "success",
            "type": "bool"
          },
          {
            "internalType": "uint16",
            "name": "damage",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "healing",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "statusApplied",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "statusCured",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "targetDied",
            "type": "bool"
          }
        ],
        "internalType": "struct Magic.SpellResult",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "currentStatus",
        "type": "uint8"
      }
    ],
    "name": "cureStatus",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      }
    ],
    "name": "getBuffModifiers",
    "outputs": [
      {
        "components": [
          {
            "internalType": "int16",
            "name": "attackBonus",
            "type": "int16"
          },
          {
            "internalType": "int16",
            "name": "defenseBonus",
            "type": "int16"
          },
          {
            "internalType": "int16",
            "name": "evasionBonus",
            "type": "int16"
          },
          {
            "internalType": "int16",
            "name": "hitRateBonus",
            "type": "int16"
          },
          {
            "internalType": "uint8",
            "name": "extraHits",
            "type": "uint8"
          }
        ],
        "internalType": "struct Magic.BuffModifiers",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellLevel",
        "type": "uint8"
      }
    ],
    "name": "getManaCost",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "getSpellDef",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "power",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "element",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.SpellTarget",
            "name": "target",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accuracy",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "statusEffect",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "statusChance",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "isHealing",
            "type": "bool"
          },
          {
            "internalType": "uint8",
            "name": "classRestriction",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.SpellDef",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "getSpellLevel",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.CharacterClass",
            "name": "class_",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint24",
            "name": "experience",
            "type": "uint24"
          },
          {
            "internalType": "uint16",
            "name": "currentHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "currentMP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxMP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "weapon",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "armor",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "helmet",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "gloves",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accessory",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.StatusEffect",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint8[8]",
            "name": "spellCharges",
            "type": "uint8[8]"
          },
          {
            "internalType": "uint8[8]",
            "name": "maxSpellCharges",
            "type": "uint8[8]"
          }
        ],
        "internalType": "struct IGameTypes.Character",
        "name": "caster",
        "type": "tuple"
      },
      {
        "internalType": "uint8",
        "name": "spellLevel",
        "type": "uint8"
      }
    ],
    "name": "hasCharges",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "isHealingSpell",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "isMultiTarget",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "spellData",
    "outputs": [
      {
        "internalType": "contract SpellData",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const WorldABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidDirection",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidLocationId",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidPosition",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "LocationLocked",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RequiresAirship",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RequiresShip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "TileNotWalkable",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "MAX_LOCATIONS",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "locationId",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "storyFlags",
        "type": "uint256"
      },
      {
        "internalType": "uint32",
        "name": "keyItems",
        "type": "uint32"
      }
    ],
    "name": "canEnter",
    "outputs": [
      {
        "internalType": "bool",
        "name": "canEnter",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "checkEncounter",
    "outputs": [
      {
        "internalType": "bool",
        "name": "triggered",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "encounterTables",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "dungeonId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "floor",
        "type": "uint8"
      }
    ],
    "name": "getDungeonEncounterTable",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "tableId",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "getEncounterGroup",
    "outputs": [
      {
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      }
    ],
    "name": "getEncounterRate",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      }
    ],
    "name": "getLocationAt",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "locationId",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "locationId",
        "type": "uint8"
      }
    ],
    "name": "getLocationInfo",
    "outputs": [
      {
        "components": [
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "enum World.LocationType",
            "name": "locationType",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "x",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "y",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "encounterTableId",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "maxFloors",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "requiredStoryFlag",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "requiredKeyItem",
            "type": "uint32"
          }
        ],
        "internalType": "struct World.Location",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      }
    ],
    "name": "getTileType",
    "outputs": [
      {
        "internalType": "enum World.TileType",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      }
    ],
    "name": "isWalkable",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "name": "locations",
    "outputs": [
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "internalType": "enum World.LocationType",
        "name": "locationType",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "encounterTableId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "maxFloors",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "requiredStoryFlag",
        "type": "uint8"
      },
      {
        "internalType": "uint32",
        "name": "requiredKeyItem",
        "type": "uint32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum World.TileType",
        "name": "",
        "type": "uint8"
      }
    ],
    "name": "terrainInfo",
    "outputs": [
      {
        "internalType": "bool",
        "name": "walkable",
        "type": "bool"
      },
      {
        "internalType": "uint8",
        "name": "encounterRate",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "difficulty",
        "type": "uint8"
      },
      {
        "internalType": "bool",
        "name": "requiresShip",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "requiresAirship",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "dungeonId",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "floor",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "direction",
        "type": "uint8"
      }
    ],
    "name": "validateDungeonMove",
    "outputs": [
      {
        "internalType": "bool",
        "name": "valid",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "fromX",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "fromY",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "toX",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "toY",
        "type": "uint8"
      }
    ],
    "name": "validateMove",
    "outputs": [
      {
        "internalType": "bool",
        "name": "valid",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "worldSeed",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const RandomnessABI = [
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bytes32",
        "name": "commitment",
        "type": "bytes32"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "blockNumber",
        "type": "uint256"
      }
    ],
    "name": "Committed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bytes32",
        "name": "secret",
        "type": "bytes32"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "name": "Revealed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "MAX_BLOCKS",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "MIN_BLOCKS",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "canReveal",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "commitment",
        "type": "bytes32"
      }
    ],
    "name": "commit",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "commitBlocks",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "commitments",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "hasCommitment",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "secret",
        "type": "bytes32"
      },
      {
        "internalType": "uint8",
        "name": "actionType",
        "type": "uint8"
      },
      {
        "internalType": "bytes",
        "name": "actionData",
        "type": "bytes"
      }
    ],
    "name": "reveal",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "randomSeed",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;

export const ClassDataABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.ItemType",
        "name": "itemType",
        "type": "uint8"
      }
    ],
    "name": "canEquip",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      }
    ],
    "name": "getBaseStats",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "strength",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intelligence",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitality",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luck",
            "type": "uint8"
          },
          {
            "internalType": "uint16",
            "name": "baseHP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "baseMP",
            "type": "uint16"
          }
        ],
        "internalType": "struct ClassData.BaseStats",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "level",
        "type": "uint8"
      }
    ],
    "name": "getExpForLevel",
    "outputs": [
      {
        "internalType": "uint24",
        "name": "",
        "type": "uint24"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "spellLevel",
        "type": "uint8"
      }
    ],
    "name": "getMaxChargesForSpellLevel",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      }
    ],
    "name": "getMaxSpellCharges",
    "outputs": [
      {
        "internalType": "uint8[8]",
        "name": "",
        "type": "uint8[8]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      }
    ],
    "name": "getStatGrowth",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "hpPerLevel",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "mpPerLevel",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "strGrowth",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agiGrowth",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "intGrowth",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "vitGrowth",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "luckGrowth",
            "type": "uint8"
          }
        ],
        "internalType": "struct ClassData.StatGrowth",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "level",
        "type": "uint8"
      }
    ],
    "name": "getStatsForLevel",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "maxHP",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "maxMP",
        "type": "uint16"
      },
      {
        "internalType": "uint8",
        "name": "str",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "agi",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "intel",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "vit",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "lck",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const ItemDataABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      }
    ],
    "name": "canUse",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      }
    ],
    "name": "getItem",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum IGameTypes.ItemType",
            "name": "itemType",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "power",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accuracy",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "critBonus",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "element",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "spellEffect",
            "type": "uint8"
          },
          {
            "internalType": "uint16",
            "name": "price",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "classRestriction",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.ItemDef",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      }
    ],
    "name": "getPrice",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "",
        "type": "uint16"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      }
    ],
    "name": "getSellPrice",
    "outputs": [
      {
        "internalType": "uint16",
        "name": "",
        "type": "uint16"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const SpellDataABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "enum IGameTypes.CharacterClass",
        "name": "class_",
        "type": "uint8"
      },
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "canLearn",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "getSpell",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint8",
            "name": "level",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "power",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "element",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.SpellTarget",
            "name": "target",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accuracy",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "statusEffect",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "statusChance",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "isHealing",
            "type": "bool"
          },
          {
            "internalType": "uint8",
            "name": "classRestriction",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.SpellDef",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "getSpellLevel",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "isHealingSpell",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

export const EnemyDataABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotEquip",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotFlee",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CharacterDead",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CommitmentRequired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "GameAlreadyExists",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientGil",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientSpellCharges",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAction",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidClass",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidItem",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMove",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidTarget",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InventoryFull",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NoActiveGame",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInCombat",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotYourTurn",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "RevealTooSoon",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "victory",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "expGained",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "gilGained",
        "type": "uint16"
      }
    ],
    "name": "CombatEnded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[8]",
        "name": "enemyIds",
        "type": "uint8[8]"
      }
    ],
    "name": "EncounterStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8[4]",
        "name": "classes",
        "type": "uint8[4]"
      }
    ],
    "name": "GameCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "itemId",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "quantity",
        "type": "uint8"
      }
    ],
    "name": "ItemObtained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "newLevel",
        "type": "uint8"
      }
    ],
    "name": "LevelUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "x",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "y",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "mapId",
        "type": "uint8"
      }
    ],
    "name": "Moved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "characterIndex",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "spellId",
        "type": "uint8"
      }
    ],
    "name": "SpellLearned",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "flagIndex",
        "type": "uint8"
      }
    ],
    "name": "StoryFlagSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "actor",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "action",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "target",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "value",
        "type": "uint16"
      }
    ],
    "name": "TurnExecuted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint8[]",
        "name": "enemyIds",
        "type": "uint8[]"
      }
    ],
    "name": "getEnemies",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "attack",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "defense",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "magicDef",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accuracy",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "evasion",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "critRate",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "weakness",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "resistance",
            "type": "uint8"
          },
          {
            "internalType": "uint16",
            "name": "expReward",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "gilReward",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "dropItemId",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "dropRate",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.EnemyDef[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "enemyId",
        "type": "uint8"
      }
    ],
    "name": "getEnemy",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "maxHP",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "attack",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "defense",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "magicDef",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "agility",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "accuracy",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "evasion",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "critRate",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "weakness",
            "type": "uint8"
          },
          {
            "internalType": "enum IGameTypes.Element",
            "name": "resistance",
            "type": "uint8"
          },
          {
            "internalType": "uint16",
            "name": "expReward",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "gilReward",
            "type": "uint16"
          },
          {
            "internalType": "uint8",
            "name": "dropItemId",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "dropRate",
            "type": "uint8"
          }
        ],
        "internalType": "struct IGameTypes.EnemyDef",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint8",
        "name": "enemyId",
        "type": "uint8"
      }
    ],
    "name": "isBoss",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;

// Re-export with standardized names
export const GameABI = CrystalsGameABI;
